import React, {useState} from "react"
import {NavLink, Link} from "react-router-dom"
import useAuth from "auth/useAuth"
import useRescuers from "hooks/useRescuers"
import Rescuer from "components/Rescuer"
import classNames from "classnames"
import "./Menu.css"

// You, as a rescuer chip. Loads the rescuer list (usually from the local cache) for the photo;
// until then the name from the login token stands in
function MenuUser({username, user}) {

    const {getUser} = useRescuers()

    const initials = [user?.given_name, user?.family_name].map(name => name?.[0] || "").join("")
    const rescuer = getUser(username) || {
        username,
        given_name: user?.given_name,
        family_name: user?.family_name,
        nickname: user?.nickname,
        initials
    }

    return <Rescuer rescuer={rescuer} onClick="profile"/>
}

export default function Menu() {

    const {logout, username, user, admin} = useAuth()
    const [open, setOpen] = useState(false)
    // The user chip mounts on first open, so pages don't fetch the rescuer list just for the menu
    const [opened, setOpened] = useState(false)

    const toggle = (event) => {
        setOpen(prev => !prev)
        setOpened(true)
    }

    return <nav className={classNames({"open": open, "closed": !open})}>
        <div id="top">            
            <Link to="/" id="top-1" className="top">
                <img src="/images/favicon.png" alt=""/>
                <div>Gorska služba spasavanja Srbije</div>
            </Link>
            
            <div id="top-2" className="top">
                <Link to="/search"><i className="fa-solid fa-magnifying-glass"/></Link>
            </div>
            
            <div id="top-3" className="top">
                <button onClick={toggle} id="nav-icon3" className={classNames({"open": open})}>
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </button>
            </div>
        </div>
        
        <div id="menu" className={classNames({"open": open})}>
            <div id="info">
                <div className="me" title="Moj profil" onClick={toggle}>
                    {opened && <MenuUser username={username} user={user}/>}
                </div>
                <button className="logout" onClick={logout}>
                    <i className="fa-solid fa-arrow-right-from-bracket"/> Odjava
                </button>
            </div>
        
            <div id="menu-inner">
                <div className="menu">
                    <h4>Povredne liste</h4>
                    <ul>
                        <li><NavLink to="/rescue" onClick={toggle}>Nova lista</NavLink></li>
                        <li><NavLink to="/" onClick={toggle}>Moje liste</NavLink></li>
                        <li><NavLink to="/rescues" onClick={toggle}>Pretraga lista</NavLink></li>
                        <li><NavLink to="/report" onClick={toggle}>Dnevni izveštaj</NavLink></li>
                    </ul>
                </div>

                <div className="menu">
                    <h4>Smene</h4>
                    <ul>
                        <li><NavLink to="/shift" onClick={toggle}>Trenutne smene</NavLink></li>
                        <li><NavLink to="/apply" onClick={toggle}>Prijava smena</NavLink></li>
                        <li><NavLink to="/roster" onClick={toggle}>Priprema smene</NavLink></li>
                        <li><NavLink to="/timeline" onClick={toggle}>Pregled smena</NavLink></li>
                    </ul>
                </div>
                
                <div className="menu">
                    <h4>Aktivnosti</h4>
                    <ul>
                        <li><a href="https://activities.gss.rs" onClick={toggle} target="_blank" rel="noreferrer">Ona druga aplikacija</a></li>
                    </ul>
                </div>

                <div className="menu">
                    <h4>Spasioci</h4>
                    <ul>
                        <li><NavLink to="/rescuers" onClick={toggle}>Pretraga spasilaca</NavLink></li>
                        {admin && <li><NavLink to="/rescuer/new" onClick={toggle}>Novi spasilac</NavLink></li>}
                    </ul>
                </div>

                <div className="menu">
                    <h4>Info</h4>
                    <ul>
                        <li><NavLink to="/analytics" onClick={toggle}>Analitika</NavLink></li>
                        <li><NavLink to="/faq" onClick={toggle}>Česta pitanja</NavLink></li>
                        <li><NavLink to="/handbooks" onClick={toggle}>Priručnici</NavLink></li>
                        <li><a href="https://wiki.gss.rs" onClick={toggle} target="_blank" rel="noreferrer">Wiki</a></li>
                    </ul>
                </div>

                {admin && <div className="menu">
                    <h4>Admin</h4>
                    <ul>
                        <li><NavLink to="/admin" onClick={toggle}>Admin</NavLink></li>
                    </ul>
                </div>}
            </div>
        </div>
    </nav>
}